import React from 'react';
import '../../css/Login.css';
import OtpTimerComponent from './OtpTimerComponent';
import { toast } from 'react-toastify';
import Utils from '../../helper/Utils';

const VerifyOtp = (props) => {
	const { close, onChangeHandler, CheckRequiredFields, requiredFields, details,} = props;
	

	return (
		<div className="card employee-application-card-style-1">
			<div>
				<div className="formHeader">
					<h3 className="headTypo">
						Verifying Email
						<button type="button" className="removeButton" onClick={close}>
							&times;
						</button>
					</h3>
				</div>
				<div className="formBody">
					<div className="form-group has-feedback formWrapper">
						<p style={{ fontSize: '0.9rem', marginBottom: 25 }}>
							One Time Password (OTP) has been sent to your registered email ID
						</p>
					</div>
					<div className="form-group has-feedback formWrapper">
						<label className="formlabel">
							Enter OTP (One Time Password)
						</label>
						<span className="loginsRequiredText">*</span>
						<input
							className="form-control input"
							value={details.otp}
							onChange={onChangeHandler}
							name="otp"
							type="text"
							placeholder="OTP"
							onKeyDown={(e)=>Utils.isKeyBoardEnterPressed(e)?CheckRequiredFields('otp'):""}
						/>
						{requiredFields.otpReqError ? (
							<p className="ValidationError">
								<i className="fa fa-warning warningIcon" />Please enter your OTP
							</p>
						) : null}
					</div>
				</div>

				<div className="formFooter">
					<button className="ContinueButton" 
					onClick={() => {
							if (details.otp.length === 6) {
							CheckRequiredFields('otp');
							} else {
							toast.error("Invalid OTP length. Please enter a 6-digit OTP.");
							}
						}}>
						Verify OTP
					</button>
					<br />
					<span className="span">
						<span name="login" className="link link-primary" >
							{/* <OtpTimerComponent details={details}/> */}
							<span name="login" className="link link-primary">
  <OtpTimerComponent details={details} clearOTPField={() => onChangeHandler({ target: { name: 'otp', value: '' } })} />
</span>

						</span>
					</span>
				</div>
			</div>
		</div>
	);
};

export default VerifyOtp;
